import React, { useEffect } from 'react';
import { Link, useLocation } from "react-router-dom";

import "@/app/pages/businessDirectory/ContactDirectoryIndustryBrowseFragment/ContactDirectoryIndustryBrowseFragmentStyles.scss";
import { ContactDirectoryIndustryBrowseFragmentParameter, TitleUrl } from "@/app/pages/businessDirectory/ContactDirectoryIndustryBrowseFragment/interface";
import { IndustryCollapsible } from "@/components/IndustryCollapsible";

type ContactDirectoryIndustryBrowseFragmentComponentProps = ContactDirectoryIndustryBrowseFragmentParameter;

interface RelatedIndustryProps {
	"headerTextLabel": string | undefined;
	"industryTitleUrlRewritten": TitleUrl[][];
	"isSingleSearchIndustryTab": boolean;
}

const RelatedIndustry = (props: RelatedIndustryProps): JSX.Element => {
	const {
		headerTextLabel,
		industryTitleUrlRewritten,
		isSingleSearchIndustryTab
	} = props;

	const { pathname } = useLocation();

	useEffect(() => {
		window.scrollTo(0,0)
	},[])

	const handleScrollPosition = (): void => {
		window.scrollTo(0,0)
	}

	if (!industryTitleUrlRewritten) return <></>;

	// Sorting the industry results alphabetically
	industryTitleUrlRewritten.sort((ar, arr) => ar[0]!.title.localeCompare(arr[0]!.title));

	const leftColumn: TitleUrl[][] = [];
	const rightColumn: TitleUrl[][] = [];

	let i = 0;

	for (const ar of industryTitleUrlRewritten) {
		(i % 2 === 0 ? leftColumn : rightColumn).push(ar);

		i += 1;
	}

	const getColumn = (titleUrlArrayArray: TitleUrl[][]) =>
		<div className={isSingleSearchIndustryTab ? "singleSearchIndustry-column" : "accordion-column"}>
			{titleUrlArrayArray.map((ti, nu) => {
				// This is the broader category
				
				const firstItem = ti[0]!;

				return <div
					className="accordionItems"
					key={nu}
				>
					<IndustryCollapsible
						header={firstItem.title}
						iconButtonClassName="accordionTrigger"
						titleClassName="accordion-title"
					>
						<div className="grid detail">
							{
								ti.map((tit, num) =>
									<Link
										className="gridLink anchor-hover-none"
										to={
											pathname.includes("contact-directory") ?
												tit.url.replace("business-directory/industry-analysis", "contact-directory/contact-industry-search") : tit.url
										}
										state={{ naics: tit.naics }}
										onClick={handleScrollPosition} 
										key={num}>
										{tit.title}
									</Link>
								)
							}
						</div>
					</IndustryCollapsible>
				</div>;
			})}
		</div>;

	return (
		<div className={isSingleSearchIndustryTab ? "singleSearchIndustry-landingRelatedIndustryWrapper" : "landingRelatedIndustryWrapper"}>
			<div className={isSingleSearchIndustryTab ? "singleSearchIndustry-landingRelatedIndustryAccordion" : "landingRelatedIndustryAccordion"}>
				<div className={isSingleSearchIndustryTab ? "singleSearchIndustry-heading" : "industry-heading"}>
					{headerTextLabel ?? ""}
				</div>

				{
					industryTitleUrlRewritten.length > 0
						?
						<div className="columnsWrapper">
							{getColumn(leftColumn)}

							{getColumn(rightColumn)}
						</div>
						: <></>
				}
			</div>

			<div className={isSingleSearchIndustryTab ? "singleSearchIndustry-landingRelatedIndustryBackgroundColor" : "landingRelatedIndustryBackgroundColor"} />
		</div>
	);
};

const ContactDirectoryIndustryBrowseFragment = ({
	contactDirectoryIndustryData,
	headerTextLabel,
	additionalContainerClass
}: ContactDirectoryIndustryBrowseFragmentComponentProps): JSX.Element => {

	const {
		industryTitleUrlRewritten
	} = contactDirectoryIndustryData;

	return (
		<div className={` contact-directory-industry-container  ${additionalContainerClass}`}>
			<RelatedIndustry
				headerTextLabel={headerTextLabel}
				industryTitleUrlRewritten={industryTitleUrlRewritten}
				isSingleSearchIndustryTab={false}
			/>
		</div>
	);
};

export { ContactDirectoryIndustryBrowseFragment, RelatedIndustry };
